import axios from 'axios';
import { editSplitProducerQuery } from './queries';

const editSplitProducer = (model, key) =>
    new Promise((resolve, reject) => {
        const query = editSplitProducerQuery({ model, key });
        const request = axios.put(query.url, { ...query.body });
        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                if (errors?.response?.data?.statusCode === 422 && typeof errors?.response?.data?.message === 'string') {
                    reject(new Error(errors.response.data.message));
                    return;
                }
                reject(new Error('Unable to edit Split Producer'));
            });
    });

export default editSplitProducer;
